export default __webpack_public_path__ + "static/media/fields.35f36fdb.png";